import { Component, OnInit } from '@angular/core';

/**
 * 已弃用
 * @deprecated
 */
@Component({
  selector: 'app-expression-entity-info-grid',
  templateUrl: './expression-entity-info-grid.component.html',
  // styleUrls: ['./expression-entity-info-grid.component.css']
})
export class ExpressionEntityInfoGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
